import {  Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClaimsListService } from '../claims-list/claims-list.service';
import { BatchFileBO, EmitBo, Getbatchfile, WhereCondition } from '../claims.model';
import { BatchService } from './batches.service';
import * as pbi from "powerbi-client";
import { DatePipe } from '@angular/common';
import { CommonApiService } from 'src/app/commonapiservice';
import { ColumnChangeBO, columnWidth } from '../../employee/employee.model';
import { EnvironmentService } from 'src/app/environment.service';
@Component({
  selector: 'app-batches',
  templateUrl: './batches.component.html',
  styleUrls: ['./batches.component.scss']
})
export class BatchesComponent implements OnInit {
  BatchBo: Getbatchfile = new Getbatchfile();
  @Input() isInputOptions: EmitBo;
  @Output() isOutputOptions = new EventEmitter<EmitBo>();
  @ViewChild('gridBatch') public gridBatch: GridComponent;
  type: string = "";
  ReportView: boolean = true;
  ReportHeader: any = "";
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  public formatOptions: object;
  private onDestroy$: Subject<void> = new Subject<void>();
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  conditionlist: WhereCondition[] = [];
  arraycol: any = [];
  BatchListData: any = [];
  today = new Date().toLocaleDateString();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: object;
  batchFileinvoice = new BatchFileBO();
  ColumnArray: columnWidth[];
  public filterSettings: object;
  configuration
  public BatchData: Observable<DataStateChangeEventArgs>;
  constructor(public CommonAPI: CommonApiService,public DateService: BatchService, public datepipe: DatePipe, public toastrService: ToastrService,
    public environmentservice: EnvironmentService,
    public global: GlobalComponent,public Claimslistservice: ClaimsListService) {
    this.BatchData = DateService;
  }
  ngOnInit(): void {
    this.filterSettings = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    let page = 10;
    this.initialPage = { currentPage: 1, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: page }
    this.BatchBo.pageitem = page;
    this.getBatchesFilter();
  }
  // ...........................................onResizeBatch........................................................
  onResizeBatch(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridBatch.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }
    });
   // this.SaveColumnwidth();
    }
  }
  showColumn() {
    this.gridBatch.columnChooserModule.openColumnChooser(200, 50);
  }
  //..............................................downloadBatchFile....................................................
  downloadBatchFile(data) {
    let params = new URLSearchParams();
    params.append("FolderName", data.folderName);
    params.append("FilePath", data.filePath);
    let url = "api/BatchFile/getdownloadlink?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((responsedata) => {
      let downloadlink = responsedata[0];
      if (downloadlink != null) {
        window.open(downloadlink);
      }
      else {
        let err = "File not found";
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  //..............................pdfView..............................................................................

  //..................................................dataStateChange.....................................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.BatchBo.orderColumn = state.sorted[0].name;
        this.BatchBo.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.BatchBo.field = state.action.currentFilterObject.field;
      this.BatchBo.matchCase = state.action.currentFilterObject.matchCase;
      this.BatchBo.operator = state.action.currentFilterObject.operator;
      this.BatchBo.value = state.action.currentFilterObject.value;
      if (this.BatchBo.type == "number") {
        this.BatchBo.value = state.action.currentFilterObject.value.toString();
        this.BatchBo.field = state.action.currentFilterObject.field;
      }
      else {
        this.BatchBo.value = state.action.currentFilterObject.value;
        this.BatchBo.field = state.action.currentFilterObject.field;
      }
      if (this.BatchBo.type == "date") {
        this.BatchBo.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.BatchBo.field = state.action.currentFilterObject.field;
      }
      else {
        this.BatchBo.value = state.action.currentFilterObject.value;
        this.BatchBo.field = state.action.currentFilterObject.field;
      }
      this.BatchBo.matchCase = state.action.currentFilterObject.matchCase;
      this.BatchBo.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.BatchBo.field = "Batchno";
        this.BatchBo.matchCase = false;
        this.BatchBo.operator = "startswith";
        this.BatchBo.value = "";
      }
    }
    this.getBatchesFilter();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].BatchDetail.Pagesize != state.take) {
          this.arraycol[0].BatchDetail.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
  }
  //...................................................onActionComplete.......................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridBatch.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].BatchDetail.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].BatchDetail.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].BatchDetail.ShowColumns.length != count1 || this.arraycol[0].BatchDetail.HideColumns.length != count) {
            this.arraycol[0].BatchDetail.ShowColumns = showarr;
            this.arraycol[0].BatchDetail.HideColumns = hidearr;
            this.SaveColumnwidth();
          }
        }
      }
    }
    this.BatchBo.currentpageno = this.gridBatch.pagerModule.pagerObj.currentPage;
    this.BatchBo.pageitem = this.gridBatch.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  }
  public test(res) {
    this.BatchBo.type = res.columnType;
  }
  ///..................................................getColumnwidth......................................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].BatchDetail.Columns;

    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.gridBatch.pageSettings.pageSize = this.arraycol[0].BatchDetail.Pagesize;
    this.ColumnArray.forEach(element => {
      if (element.column == 'Batch No.') {
        const column = this.gridBatch.getColumnByField('batchno');
        column.width = element.width;
        this.gridBatch.refreshHeader();
      }
      if (element.column == 'Claim Status') {
        const column1 = this.gridBatch.getColumnByField('claimStatus');
        column1.width = element.width;
        this.gridBatch.refreshHeader();
      }
      // if (element.column == 'Company') {
      //   const column = this.gridBatch.getColumnByField('companyName');
      //   column.width = element.width;
      //   this.gridBatch.refreshHeader();
      // }
      if (element.column == 'Clearing House') {
        const column = this.gridBatch.getColumnByField('clearingHouseName');
        column.width = element.width;
        this.gridBatch.refreshHeader();
      }
      if (element.column == 'Generated Date') {
        const column = this.gridBatch.getColumnByField('createDate');
        column.width = element.width;
        this.gridBatch.refreshHeader();
      }
      if (element.column == 'Action') {
        const column2 = this.gridBatch.getColumnByUid('action');
        column2.width = element.width;
        this.gridBatch.refreshHeader();
      }
    });
  }
  //............................................SaveColumnwidthViewbatch.......................................................
  SaveColumnwidth() {
    this.arraycol[0].BatchDetail.Columns = this.ColumnArray;
    this.arraycol[0].BatchDetail.Pagesize = this.gridBatch.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
  //.................................................getBatchesFilter..........................................................
  getBatchesFilter() {
    this.DateService.outputValues(this.BatchBo);
    let count = 0;
    this.BatchData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.BatchListData = data.result;
      count = count + 1
      if (data != null && data.result.length >= 15) {
        this.gridBatch.height = "500";

      }
      else {
        this.gridBatch.height = "auto";

      }
      if (data != null && data != undefined && count == 1) {
    //    this.getColumnwidth();
      }

    })
  }
  
  //......................................................goBackToClaims.....................................................
  goBackToClaims() {
    this.isOutputOptions.emit({
      isedited: false, claimMasterId: this.isInputOptions.claimMasterId,
      tabsChanges: this.isInputOptions.tabsChanges, is87IClaim: this.isInputOptions.is87IClaim,
      ClaimsfilterDetails: this.isInputOptions.ClaimsfilterDetails, isClaimsViewEnable: true, ReadyColumns: this.isInputOptions.ReadyColumns,
      ActiveColumns: this.isInputOptions.ActiveColumns, ArchiveColumns: this.isInputOptions.ArchiveColumns, claimsStatusData: this.isInputOptions.claimsStatusData,
      groupIds: this.isInputOptions.groupIds, PayorIds: this.isInputOptions.PayorIds, masterServiceIds: this.isInputOptions.masterServiceIds
      , selectedGroupName: this.isInputOptions.selectedGroupName, companyIds: this.isInputOptions.companyIds,isClaimAttachment:false
    })
  }
//................................................GenerateReport.........................................................
  GenerateReport(List) {
    this.batchFileinvoice.fileName = List.fileName;
    this.batchFileinvoice.createDate = List.createDate;
    this.batchFileinvoice.batchno = List.batchno;
    this.batchFileinvoice.id = List.id; 
     let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.ReportView = true;
    this.ReportHeader = "View 837";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("open837Modal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.environmentservice?.Environments?.ViewBatchReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:id=" +
        this.batchFileinvoice.id +
        "&rp:batchno=" +
        this.batchFileinvoice.batchno +
        "&rp:filename=" +
        this.batchFileinvoice.fileName +
        "&rp:createdate=" + 
        this.global.getDateTimeString(this.batchFileinvoice.createDate)+
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      
       let embedReportId =  this.environmentservice?.Environments?.ViewBatchReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
//................................................close837Modal.........................................................
  close837Modal() {
    document.getElementById("open837Modal").click();
    this.ReportView = false;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
